import { RetryLink } from '@apollo/client/link/retry';

const retryLink = new RetryLink({
  delay: {
    initial: 300,
    max: 3000,
    jitter: true,
  },
  attempts: {
    max: 3,
    retryIf: error => {
      const isJWTExpired =
        error?.result?.errors?.[0]?.extensions?.code === 'invalid-jwt' &&
        error?.result?.errors?.[0]?.message?.includes('JWTExpired');

      return Boolean(isJWTExpired);
    },
  },
});

export default retryLink;
